import React from 'react';
import { Link } from 'react-router-dom';

// Hosts, die zur eigenen Website gehören (backend.gruen-weiss.at o. Ä. bewusst nicht)
const OWN_HOSTS = ['gruen-weiss.at', 'www.gruen-weiss.at'];

// Liefert den internen Pfad (z. B. "/news/xyz?a=1#b"), wenn der Link auf die eigene Website zeigt, sonst null
export const getInternalPath = (href) => {
	if (!href || typeof href !== 'string') return null;
	if (href.startsWith('/') && !href.startsWith('//')) return href;
	try {
		const url = new URL(href, window.location.origin);
		if (!/^https?:$/.test(url.protocol)) return null;
		const host = url.host.toLowerCase();
		if (!OWN_HOSTS.includes(host) && host !== window.location.host.toLowerCase()) return null;
		// index.php/Dateien (PDF, Bilder …) nicht über den Router öffnen
		if (/\.[a-z0-9]{2,4}$/i.test(url.pathname)) return null;
		return `${url.pathname}${url.search}${url.hash}`;
	} catch {
		return null;
	}
};

// Eigene Domain → im selben Tab über den Router, externe Links → neuer Tab
export function SmartLink({ href, children, ...props }) {
	const internalPath = getInternalPath(href);
	if (internalPath) {
		return <Link to={internalPath} {...props}>{children}</Link>;
	}
	return <a href={href} target="_blank" rel="noreferrer" {...props}>{children}</a>;
}
